/*
 * @japa/runner
 *
 * (c) Japa
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export * from '@japa/core/types'

export type BaseReporterOptions = {
  stackLinesCount?: number
  framesMaxLimit?: number
}
